import { render, staticRenderFns } from "./CourierServiceEdit.vue?vue&type=template&id=e762cc6e&scoped=true&"
import script from "./CourierServiceEdit.vue?vue&type=script&lang=js&"
export * from "./CourierServiceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e762cc6e",
  null
  
)

export default component.exports